const SERVER_SIDE_API_URL = process.env.SERVER_SIDE_API_URL || "http://host.docker.internal:8080"

export const API_BASE_URL =
	typeof window === "undefined"
		? SERVER_SIDE_API_URL
		: (process.env.NEXT_PUBLIC_API || "http://localhost:8000")